import React, { useState } from 'react';
import { Formik } from 'formik';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import PasswordField from '../PasswordField/PasswordField';

const validate = ({ email, currentPassword }) => {
  const errors = {};
  const requiredFieldError = "This field can't be blank";

  if (!email.trim()) errors.email = requiredFieldError;
  else if (!/^\S+@\S+\.\S+$/.test(email.trim())) errors.email = 'Enter valid email address';
  if (!currentPassword) errors.currentPassword = requiredFieldError;

  return errors;
};

const ChangeEmailDialog = ({ onClose, onSubmit }) => {
  const [error, setError] = useState('');

  const submit = async ({ email, currentPassword }) => {
    setError('');
    try {
      await onSubmit(email.trim(), currentPassword);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Formik
      initialValues={{ email: '', currentPassword: '' }}
      validate={validate}
      validateOnChange={false}
      onSubmit={submit}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <Dialog open onClose={isSubmitting ? undefined : onClose} fullWidth maxWidth="xs">
          <form
            autoComplete="off"
            onSubmit={(e) => {
              // React bubbles the submit through the portal into the profile form
              e.stopPropagation();
              handleSubmit(e);
            }}
          >
            <DialogTitle>Change email</DialogTitle>
            <DialogContent>
              <label htmlFor="newEmail">
                <Typography variant="body1" color="textSecondary">
                  New Email:
                </Typography>
                <TextField
                  type="text"
                  id="newEmail"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(errors.email) && Boolean(touched.email)}
                  variant="outlined"
                  inputProps={{ 'aria-label': 'New email' }}
                  fullWidth
                />
                {errors.email && touched.email ? <div className={'error'}>{errors.email}</div> : null}
              </label>
              <label htmlFor="currentPassword">
                <Typography variant="body1" color="textSecondary">
                  Current Password:
                </Typography>
                <PasswordField
                  id="currentPassword"
                  autoComplete="current-password"
                  value={values.currentPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(errors.currentPassword) && Boolean(touched.currentPassword)}
                  inputProps={{ 'aria-label': 'Current password' }}
                />
                {errors.currentPassword && touched.currentPassword ? (
                  <div className={'error'}>{errors.currentPassword}</div>
                ) : null}
              </label>
              {error && <div className={'error'}>{error}</div>}
            </DialogContent>
            <DialogActions>
              <Button color="secondary" onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                Send link
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    </Formik>
  );
};

export default ChangeEmailDialog;
